import { IFourVariantXP } from '../../indigofair/settings/IFourVariantXP';
import { SettingConst } from '../../types';

/**
 * Testing new copy and treatment for the global banner
 */
export const GLOBAL_BANNER_COPY_120424 =
  'GLOBAL_BANNER_COPY_120424' as SettingConst<
    'GLOBAL_BANNER_COPY_120424',
    keyof typeof IFourVariantXP.Bucket,
    'RETAILER'
  >;
